/**
 * This needs to exists for the dashboard to load, otherwise the appointments cannot be opened
 */
function init_teacher_menu_widget() {
    // NOOP
}